import { render } from "./IconDownload.vue?vue&type=template&id=03f3d2b7"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03f3d2b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03f3d2b7', __exports__)) {
    api.reload('03f3d2b7', __exports__)
  }
  
  module.hot.accept("./IconDownload.vue?vue&type=template&id=03f3d2b7", () => {
    api.rerender('03f3d2b7', render)
  })

}


export default __exports__